export default function TextViewAnswer({ answer }) {
  return <p>{answer.answer_text || ''}</p>;
}
